import './index.scss';
import './screens/screens.scss';

export default {
  NavigationController: require('./navigation_controller').default,
  Screens: {
    BookingInitial: require('./screens/booking_initial').default,
    BookingAddons: require('./screens/booking_addons').default,
    CheckoutPersonal: require('./screens/checkout_personal').default,
    CheckoutPayment: require('./screens/checkout_payment').default,
    AdditionalInformation: require('./screens/additional_information').default,
    GuestInformation: require('./screens/guest_information').default,
    CheckoutSummary: require('./screens/checkout_summary').default,
  },
};
